import { createAsyncThunk } from '@reduxjs/toolkit'
import { IFaxCoversheet } from '@dataTypes/fax.type'
import {
  createCoversheet,
  getAllCoversheets,
} from '@services/api/fax/coversheet.api'

export const fetchAllCoversheets = createAsyncThunk<
  IFaxCoversheet[],
  void,
  { rejectValue: string }
>('api/fax/coversheets/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await getAllCoversheets()
    if (response.statusCode >= 400) {
      return rejectWithValue(response.message)
    }
    return (response.data?.fax_coversheets ?? []) as IFaxCoversheet[]
  } catch (error: unknown) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'An error occurred',
    )
  }
})

export const addCoversheet = createAsyncThunk<
  IFaxCoversheet,
  IFaxCoversheet,
  { rejectValue: string }
>('api/fax/coversheets/add', async (data, { rejectWithValue }) => {
  try {
    const response = await createCoversheet(data)
    if (response.statusCode >= 400 || !response.data?.fax_coversheet) {
      return rejectWithValue(response.message)
    }
    return response.data.fax_coversheet as IFaxCoversheet
  } catch (error: unknown) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'An error occurred',
    )
  }
})
